import { Typography } from "@mui/material";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import React, { useEffect } from "react";
import styles from "./TextField.module.css";

function TextField({
  disablePaste,
  numberValidation,
  textValidation,
  errors,
  register,
  required,
  name,
  readOnly,
  label,
  type,
  placeholder,
  icon,
  handleAction,
  dateMax,
  disabled,
  watch,
  setValue,
  onChange,
  autoComplete
}) {
  const value = watch && watch(name, "");

  useEffect(() => {
    if (textValidation) {
      setValue(name, value?.replace(/[^a-z ]/gi, ""));
    } else if (numberValidation) {
    
      setValue(name, value?.replace(/[^0-9 .]*$/, ""));
    }
  }, [value]);

  const handleKeyDown = (event) => {
    if (event.key === "ArrowUp" || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  };

  return (
    <label className={styles.textfield} htmlFor="">
      <div className={styles.heading}>
        <Typography>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Typography>
      </div>

      <div className={styles.input_box}>
        {register ? (
          <input
            onKeyDown={handleKeyDown}
            onPaste={(e) => {
              return disablePaste ? e.preventDefault() : null;
            }}
            {...register(name)}
            readOnly={readOnly}
            type={type}
            max={dateMax && new Date().toISOString().slice(0, 10)}
            placeholder={placeholder}
            disabled={disabled}
            autoComplete={autoComplete ? 'on' : 'off'}
          />
        ) : (
          <input
            type={type}
            max={dateMax && new Date().toISOString().slice(0, 10)}
            placeholder={placeholder}
            value={value}
            disabled={disabled}
            onChange={onChange}
            autoComplete={autoComplete ? 'on' : 'off'}
          />
        )}

        {icon && (
          <div
            onClick={() => {
              handleAction();
            }}
            className={styles.icon}
          >
            <img src={icon} alt="" />
          </div>
        )}
      </div>

      {errors && errors[name] && (
        <ValidationMessage message={errors[name]?.message} />
      )}
    </label>
  );
}

export default TextField;
